import type { EventCapturer } from '#src/analytics/analytics_event.ts';
import {
  GroupLinkCopyEvent,
  GroupLinkViewEvent,
} from '#src/groups/analytics/group_analytics_events.ts';
import successIllustration from '#src/pages/create/create_group_success_card/assets/success.png';
import { AnchorAsButton } from '@packages/ui/base/button/anchor_as_button';
import { Card } from '@packages/ui/base/card/card';
import { CopyButton } from '@packages/ui/clipboard/copy_button';
import { ArrowUpRightIcon, LinkIcon } from '@phosphor-icons/react';

export interface CreateGroupSuccessCardProps {
  captureEvent: EventCapturer;
  /** Absolute link participants use to draw their match. */
  groupUrl: string;
}

export const CreateGroupSuccessCard = ({ captureEvent, groupUrl }: CreateGroupSuccessCardProps) => {
  return (
    <Card className="text-left">
      <img
        src={successIllustration}
        alt="Checkmark with confetti"
        className="mb-6 size-20 rounded-sm"
      />

      <h1 className="mb-2 text-xl font-bold">Your draw link is ready!</h1>

      <div className="text-muted-foreground mb-6">
        Share this link with everyone to let them draw their match.
      </div>

      {/* Link Display */}
      <div className="border-primary/30 mb-4 flex items-center gap-3 rounded-sm border text-left">
        <div className="bg-primary/10 border-primary/30 flex items-center justify-center rounded-s-sm border-r p-2.5">
          <LinkIcon className="text-primary/80 size-4" weight="bold" />
        </div>
        <div className="flex-1 truncate">
          <p className="truncate text-sm">{groupUrl}</p>
        </div>
      </div>

      {/* Footer */}
      <div className="flex items-center gap-2">
        <CopyButton
          toCopy={groupUrl}
          notCopiedLabel="Copy link"
          copiedLabel="Copied!"
          onCopy={() => captureEvent(GroupLinkCopyEvent, {})}
        />
        <AnchorAsButton
          href={groupUrl}
          target="_blank"
          variant="secondary"
          className="flex items-center"
          onClick={() => captureEvent(GroupLinkViewEvent, {})}
        >
          <span>View</span>
          <ArrowUpRightIcon className="ml-2 size-4" weight="bold" />
        </AnchorAsButton>
      </div>
    </Card>
  );
};
